module.exports = __webpack_public_path__ + "img/left-indentation.a90343d1.svg";